
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSimplifiedBeaconCardinalWest as ObiSimplifiedBeaconCardinalWestElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-simplified-beacon-cardinal-west.js';
 
 
 

 
 export const ObiSimplifiedBeaconCardinalWest = createComponent({
   react: React,
   tagName: 'obi-simplified-beacon-cardinal-west',
   elementClass: ObiSimplifiedBeaconCardinalWestElement,
   events: {
     
   }
  });
 
 